import React from 'react';
import PropTypes from 'prop-types';

function notifyException(exception, info) {
    if (!window.Bugsnag) {
        return;
    }

    window.Bugsnag.notifyException(exception, info);
}

export default class ErrorBoundary extends React.Component {
    componentDidCatch(error, info) {
        notifyException(error, { react: info });
    }

    render() {
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/js/components/ErrorBoundary.jsx